

















import { EnterpriceBankData } from '@/store/interfaces/company';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'UsdtBankData',
  props: {
    bankData: {
      type: Object as PropType<EnterpriceBankData>,
      required: true,
    },
  },
});
